import {
    PREDICTION_HISTOGRAM_DRAW_BAR,
    PREDICTION_HISTOGRAM_DRAW_PAINT,
    HISTOGRAM_CHART,
    SCATTERPLOT_CHART,
    PREDICTION,
    ACTUAL,
    SEEDATA,
    LINE_CHART,
    COMBINED,
    COMBINEDSTACKEDBARCHART,
    COMBINEDGROUPBARCHART,
    PREDICTION_HISTOGRAM_CANVAS_CLEAR,
    PREDICTION_HISTOGRAM_CANVAS_PENCIL,
    BAR_CHART,
    PARALLEL_COORDINATES_CHART
} from "../../Canvas/Constants";
import * as buckets from 'buckets-js'
import classNames from 'classnames';
import {
    histogramPredictionDataset,
    HistogramPrediction,
    brushingDataset,
    BrushingDataSet,
    BrushingPointsBarChart,
    PredictionPointsParallelCoordinates,
    ParallelCoordinateBrushObject,
    ParallelCoordinatesPrediction
} from "../../../Globals/Globals";
import {
    brushingFilterDataset,
    BrushingFilterBarChart
} from '../../../Globals/BrushingFIlterDataset'

import {
    brush as d3brush,
    select as d3select,
    brushSelection as d3brushSelection
  } from "d3";
import { GraphPredictContext } from "../../Canvas/GraphPredictContext";
import * as React from "react";
import { extent as d3ArrayExtent, histogram, range as d3Range } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import { min as d3min, max as d3max } from "d3";
import {
    scaleLinear as d3ScaleLinear,
    scalePoint as d3ScalePoint,
    scaleOrdinal as d3ScaleOrdinal
} from "d3-scale";
import * as d3 from "d3";
import { schemeCategory10 as d3SchemeCategory10, event as d3event } from "d3";

import {
    select as d3Select,
    selectAll as d3SelectAll,
    event as d3event1
} from "d3-selection";
import { line as d3Line } from "d3-shape";

import * as aggregation from "../../aggregation/countAggregation";
import { func } from "prop-types";
import { useState } from "react";
import * as interactfuncs from "../../../libtsx/interactfuncs";

import { PREDICTION_COLOR, REALDATA_COLOR, BRUSHING_COLOR, NO_PREDICTION_COLOR } from "../../../Globals/ColorConstants"
import {dimensions, loadValues1, loadValues} from '../../aggregation/countAggregation'

import { histogramBrush } from "../../Brushing/HistogramBrush";
import { scatterPlotBrush } from "../../Brushing/ScatterPlotBrush";
import { lineChartBrush } from "../../Brushing/LineChartBrush";
import { parallelCoordinatesPlotBrush } from "../../Brushing/ParallelCoordinatesBrush";
import { barChartBrush } from "../../Brushing/BarChartBrush";

import {d3multibrush, d3v3event, d3v4eventthis} from  '../../../../libjs/d3multibrush/multibrush.js'
import {pre_brush_end, pre_brush_parallel_chart, pre_brushstart, brushStart, drawPredictionActual, drawPredictionLineActual, drawPredictionPredidction} from '../ParallelCoordinates/PredictionParallelCoordinates'
import "../../../../css/ParallelCoordinates.css"
import ReactHtmlParser from 'react-html-parser'; 
import {clearAllBrushes} from '../../Canvas/MasterGraphConfig'
import {LogEvents} from '../../../Globals/Globals'
import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
    ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, 
    LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../../Globals/LogConstants'
    

    
interface ParllelCoordinatesStates { }

interface ParllelCoordinatesProps {
    id: string;
    axis: string
    height: number;
    width: number;
}




const ParllelCoordinates: React.FC<ParllelCoordinatesProps> = ({ id, width, height, axis }) => {

    
    const { grapVisOptions, setgrapVisOptions } = GraphPredictContext();
    console.log(
        "GraphPredictContextParallel",
        grapVisOptions,
        histogramPredictionDataset,
        brushingDataset.getActualID(id)
    );

   

    var graphDraw = grapVisOptions["graphDraw"];
    var grapCanvasOptions = grapVisOptions["grapCanvasOptions"];
    var graphOptions = grapVisOptions["graphOptions"];
    var graphType = grapVisOptions["graphType"];
    var brushDimsPerm = {}
   
    var margin = { top: 30, right: 10, bottom: 30, left: 30 };
    var height = height - margin.left - margin.right;
    var width = width - margin.top - margin.bottom;
    var dims
    var dimfilters = []
    var dimBrushInstances = {}
    var brushRectIds = new Map<string, Array<any>>()
    var zaxisList = []

    if (brushingDataset.getActualID(id) != null) {
       
        var actualDataset = brushingDataset.getActualID(id)

        actualDataset.height = height
        actualDataset.width = width
       
        actualDataset.domainMin = 0
        if(actualDataset.zaxis.length == 0)
        {
            actualDataset.zaxis.push(actualDataset.xaxis)
            if(actualDataset.yaxis!='Count')
            {
                actualDataset.zaxis.push(actualDataset.yaxis)
            }
        }
        actualDataset.zaxis.push(axis)
      
        $.each(actualDataset.zaxis, function(i, el){
            if($.inArray(el, zaxisList) === -1) zaxisList.push(el);
        });

        dims = [...dimensions]
    
     
        for(var i=0;i<zaxisList.length;i++)
        {
            var filter = dims.filter(function(dim) {
                return dim.name == zaxisList[i]
            });;
            if(filter.length>0)
            {   
                filter[0]['scale'].range(([height, 0]))
                if( filter[0]['type'] == 'string')
                {
                    filter[0]['scale'].range(([0, height]))
                    filter[0]['scale'].padding(0.3)
                    filter[0]['scale'].extent = (function(){
                        var domainKeys = {}
                        var domain = filter[0]['scale'].domain()
                        var range = filter[0]['scale'].range()
                        var scale = d3.scaleQuantile().domain(domain).range(range)
                        for(var j=0;j<domain.length;j++)
                        {
                            console.log('dimfilters[i].scale.invert777', filter[0]['scale'](domain[j]))
                            domainKeys[filter[0]['scale'](domain[j])] = domain[j]

                        }
                      
                        return function(){
                            console.log('extentent', d3.event.selection)
                            if(d3.event.selection!=null)
                            {
                                return d3.event.selection
                            }
                        }

                    })()
                    filter[0]['scale'].invert = (function(){

                        var domainKeys = {}
                        var domain = filter[0]['scale'].domain()
                        var range = filter[0]['scale'].range()
                    
                        for(var j=0;j<domain.length;j++)
                        {
                         //   console.log('dimfilters[i].scale.invert777', filter[0]['scale'](domain[j]))
                            domainKeys[filter[0]['scale'](domain[j])] = domain[j]

                        }
                      
                        return function(x, y){
                            var values = []
                            Object.keys(domainKeys).forEach(key=>{
                                if(key >= x && key <=y)
                                {
                                    values.push(domainKeys[key])
                                }

                             });
                            
                             return values
                        }
                    })()
                    

                }
                
               
                dimfilters.push(filter[0])
            }
          
           
        }
        console.log('dimfilters',dimfilters)
        actualDataset.type = PARALLEL_COORDINATES_CHART
        
        actualDataset.linearScalePoint = d3.scalePoint()
    .domain(dimfilters.map(function(d) { return d.name; }))
    .range([0, width]);

    }
    var xScale = d3.scalePoint()
    .domain(dimfilters.map(function(d) { return d.name; }))
    .range([0, width]);

    var line = d3.line()
    .defined(function(d) { return !isNaN(d[1]); });

    var dimensionElements = []
    var backgroundElementsForeground = []
    var backgroundElementsBackground = []
    var  y = {}, dragging = {};
   
    var brushSelection = []
    var extents = dimfilters.map(function(p) { return [0,0]; });;
    var predInit = true

   


    React.useEffect(() => {
        console.log("useEffectParallelCoordinates");
     if (
            graphOptions == SEEDATA 
          )
          {
           
        
                
            predictionParallelCoordinates = ''
            if(histogramPredictionDataset.getPredictionParallelCoordinatesChart(id) != null)
            {
                var graph_forepaths= document.getElementsByClassName("forepath");

                for (let i = 0; i < graph_forepaths.length; i++) {
          
                  graph_forepaths[i].setAttribute(
                    "style",
                    "opacity: 0.2; stroke: "+"grey"+"; "
                    );
                }

                predictionParallelCoordinates = histogramPredictionDataset.getPredictionParallelCoordinatesChart(id)
                console.log('predictionParallelCoordinatesseedata',predictionParallelCoordinates)
                for(var row=0;row<predictionParallelCoordinates.axesPrediction.length;row++)
                {
                  var predictionParallelCoordinate:ParallelCoordinatesPrediction = predictionParallelCoordinates.axesPrediction[row]
                  var dataAll = []
                  for (let [key, value] of Object.entries(predictionParallelCoordinate.predictionPoints)) {
                        var data = value[0]
    
                       drawPredictionActual(key, value, xScale, predictionParallelCoordinate)
                        var keys = key.split(":")
                        dataAll.push([key,value])
                       
                  }
                  drawPredictionLineActual(dataAll, row)
    
                }
    
               
            }

             if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
              {
                
                histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
              {
                
                scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == BAR_CHART)
              {
                
                barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == LINE_CHART)
              {
                
                lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
              {
                
                parallelCoordinatesPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData);
              }
              
            
          }

          if( graphOptions == PREDICTION )
          {
            
            brushRectIds.clear()
            predictionParallelCoordinates = histogramPredictionDataset.getPredictionParallelCoordinatesChart(id)
            predictionParallelCoordinates.axesPrediction = new Array<ParallelCoordinatesPrediction>()
            predictionParallelCoordinates.axesPredictionBrushes = new Array<any>()
            predictionParallelCoordinates.axesPredictionBrushInstanes = new Map<string,any>()
            predictionParallelCoordinates.brush = []
            predictionParallelCoordinates.axes = []
            console.log('predictionParallelCoordinatesseedata',d3select('#'+id+'prediction'), d3select('#'+id+'prediction').empty())
            if(d3select('#'+id+'prediction').empty())
            {
                d3select('#'+id+'_svg_parallel_coordinates')
                .insert("g",'.predictionDummyyy + *')
                .attr('class','prediciton')
                .attr('id',id+'prediction')
            }
            if(histogramPredictionDataset.getPredictionParallelCoordinatesChart(id) != null)
            {
                predictionParallelCoordinates = histogramPredictionDataset.getPredictionParallelCoordinatesChart(id)
              
                for(var row=0;row<predictionParallelCoordinates.axesPrediction.length;row++)
                {
                  var predictionParallelCoordinate:ParallelCoordinatesPrediction = predictionParallelCoordinates.axesPrediction[row]
                  var dataAll = []
                  for (let [key, value] of Object.entries(predictionParallelCoordinate.predictionPoints)) {
                        var data = value[0]
                        
                        drawPredictionPredidction(id, key, value, xScale)
                        var keys = key.split(":")
                        dataAll.push([key,value])
                       
                  }
                  //drawPredictionLineActual(dataAll)
    
                }
                /*if(predictionParallelCoordinates.htmlElements.length !=0)
                {
                    
                    dimfilters.forEach(dim => {
                      
                        if(predictionParallelCoordinates.htmlElements[dim.name])
                        {  var elements = ''

                            predictionBrushElements = Array.prototype.slice.call(predictionParallelCoordinates.htmlElements[dim.name])
                           
                            for(var i=0; i<predictionBrushElements.length; i++)
                            {
                                 
                            console.log('document.getElementById',predictionBrushElements[i])
                               if([...predictionBrushElements[i].classList].includes('background'))
                               {
                                    continue
                               }
                              
                               if(predictionBrushElements[i].style.display=='')
                               {
                                console.log('test', predictionBrushElements[i].outerHTML, predictionBrushElements[i])
                                elements = elements+ predictionBrushElements[i].outerHTML
                              
                               }
                               
                            }
                           console.log('test', document.getElementById(dim.name+"_parallelCoordinates").childNodes, elements)
                        }
                       
                     
                      
                      
                    })
                }*/
              
            }
          }
    }, [graphType, graphOptions, width, height]);



        if (
            graphOptions == PREDICTION
        ) {
            var predictionParallelCoordinates
            var predictionLastBrushAxes = null
            var predictionLastBrush = null
            var predictionBrushElements:any
            if(histogramPredictionDataset.getPredictionParallelCoordinatesChart(id) == null)
            {
                predictionParallelCoordinates = histogramPredictionDataset.addPredictionParallelCoordinatesChart(id)

                dimfilters.forEach(dim => {
                    var reactpredictionBrushElements:any
                    var predictionBrushElements:any
                 
    
                    predictionParallelCoordinates.axesInit[dim.name] = true
                    dim.brush = d3multibrush()
                    .y(dim.scale)
                    .extentAdaption(newExtent.bind(this, predictionParallelCoordinates, dim, xScale, brushRectIds))
                    
                    .on("brushstart", pre_brushstart.bind(this, predictionLastBrushAxes, predictionLastBrush, dim.brush, predictionParallelCoordinates, extents, dim, xScale, ))
                    .on("brush", pre_brush_parallel_chart.bind(this, predictionLastBrushAxes, predictionLastBrush, dim.brush, predictionParallelCoordinates, extents, dim, xScale, brushRectIds, id, zaxisList))
                    .on("brushend", pre_brush_end.bind(this, predictionLastBrushAxes, predictionLastBrush, dim.brush, predictionParallelCoordinates, extents, dim, xScale, brushRectIds, id, zaxisList));
                
                    var dimensionElement =  <g className={'dimension '+dim.name} transform={'translate('+xScale(dim.name)+')'} >
                    <g className={'axis'} ref={node => d3Select(node).call(d3AxisLeft(dim.scale))}>       
                    </g>
                    <text className="title" textAnchor="middle" y={"-9"}>{dim.name}</text>
                    <g id={dim.name+"_parallelCoordinates"} className={'parallelCoordinatesbrush brush'} ref={node => d3Select(node)
                                                                        .call(dim.brush)
    
                                                                        .selectAll("rect")
                                                                        .call(resizeExtent.bind(this, predictionParallelCoordinates, dim, xScale))}>
                                                                            
                                                                                                    </g>
                    </g>
                    dimensionElements.push(dimensionElement)
    
                })

            }
            else
            {
                predictionParallelCoordinates = histogramPredictionDataset.getPredictionParallelCoordinatesChart(id)
                console.log('histogramPredictionDataset.getPredictionParallelCoordinatesChart(id)',predictionParallelCoordinates.axesPredictionBrushInstanes)
          

                if(predictionParallelCoordinates.axesPredictionBrushInstanes.length>0)
                {
                    predictionParallelCoordinates.dimfilters.forEach(dim => {

                        predictionParallelCoordinates.axesInit[dim.name] = true
                  
                    
                        var dimensionElement =  <g className={'dimension '+dim.name} transform={'translate('+xScale(dim.name)+')'} >
                        <g className={'axis'} ref={node => d3Select(node).call(d3AxisLeft(dim.scale))}>       
                        </g>
                        <text className="title" textAnchor="middle" y={"-9"}>{dim.name}</text>
                        <g id={dim.name+"_parallelCoordinates"} className={'parallelCoordinatesbrush brush'} ref={node => d3Select(node)
                                                                            .call(dim.brush)
        
                                                                            .selectAll("rect")
                                                                            .call(resizeExtent.bind(this, predictionParallelCoordinates, dim, xScale))}>
                                                                                
                                                                                                        </g>
                        </g>
                        dimensionElements.push(dimensionElement)
                    })
                }
                else
                {
                    dimfilters.forEach(dim => {
                        var reactpredictionBrushElements:any
                        var predictionBrushElements:any
                     
        
                        predictionParallelCoordinates.axesInit[dim.name] = true
                        dim.brush = d3multibrush()
                        .y(dim.scale)
                        .extentAdaption(newExtent.bind(this, predictionParallelCoordinates, dim, xScale, brushRectIds))
                        
                        .on("brushstart", pre_brushstart.bind(this, predictionLastBrushAxes, predictionLastBrush, dim.brush, predictionParallelCoordinates, extents, dim, xScale, ))
                        .on("brush", pre_brush_parallel_chart.bind(this, predictionLastBrushAxes, predictionLastBrush, dim.brush, predictionParallelCoordinates, extents, dim, xScale, brushRectIds,  id))
                        .on("brushend", pre_brush_end.bind(this, predictionLastBrushAxes, predictionLastBrush, dim.brush, predictionParallelCoordinates, extents, dim, xScale, brushRectIds, id));
                    
                        var dimensionElement =  <g className={'dimension '+dim.name} transform={'translate('+xScale(dim.name)+')'} >
                        <g className={'axis'} ref={node => d3Select(node).call(d3AxisLeft(dim.scale))}>       
                        </g>
                        <text className="title" textAnchor="middle" y={"-9"}>{dim.name}</text>
                        <g id={dim.name+"_parallelCoordinates"} className={'parallelCoordinatesbrush brush'} ref={node => d3Select(node)
                                                                            .call(dim.brush)
        
                                                                            .selectAll("rect")
                                                                            .call(resizeExtent.bind(this, predictionParallelCoordinates, dim, xScale))}>
                                                                                
                                                                                                        </g>
                        </g>
                        dimensionElements.push(dimensionElement)
        
                    })
                }
                
            }


          
            predictionParallelCoordinates.dimFilters = dimfilters
        }   
        else
        {
            dimfilters.forEach(dim => {
                    
                        console.log('extents',extents)
                        dim.brush = d3
                        .brushY()
                        .extent([[-16, 0], [16, height]])
                        .on("brush start", brushstart.bind(this, extents, dimfilters, dim.name, id, dimBrushInstances, zaxisList))
                        .on("brush", go_brush)
                        .on("brush", brush_parallel_chart.bind(this, extents, dimfilters, id, dimBrushInstances))
                        .on("end", brush_end.bind(this, extents, dimfilters, id, xScale, zaxisList));
                
                        var drag = d3.drag()
                        .subject(function() { return {x: xScale(dim.name)}; })
                        .on("start", function(d) {
                        dragging[dim.name] = xScale(dim.name);
                        d3Select(".background").attr("visibility", "hidden");
                        })
                        .on("drag", function() {
                        dragging[dim.name] = Math.min(width, Math.max(0, d3.event.x));
                        
                        var pathd3 = d3.selectAll('.forepath')
                        pathd3.each(function(d,i) {
                            d3select(this).attr("d", drawLine(loadValues1[i], line, xScale, dimfilters, dragging))
                        })
                
                        
                
                        dimfilters.sort(function(a, b) { return position(dragging, a.name, xScale) - position(dragging, b.name, xScale); });
                        xScale.domain(dimfilters.map(function(d) { return d.name; }))
                        .range([0, width]);
                        
                        var dimensionElements = document.getElementsByClassName('dimension')
                        for (let i = 0; i < dimensionElements.length; i++) {
                            var dimensioncol = dimensionElements[i].classList[1]
                        
                            dimensionElements[i].setAttribute("transform", "translate(" + position(dragging, dimensioncol, xScale) + ")")
                        }
                        
                        })
                        .on("end", function() {
                            
                            delete dragging[dim.name];
                        
                            transition(d3.select(this)).attr("transform", "translate(" + xScale(dim.name) + ")");
                
                            transition(d3.select(".foreground")
                                            .selectAll('.forepath'))
                                            .each(function(d,i) {
                                                    d3select(this).attr("d", drawLine(loadValues1[i], line, xScale, dimfilters, dragging))
                                            })
                                            
                
                            d3.select(".background")
                            .selectAll('.backpath')
                            .each(function(d,i) {
                                d3select(this).attr("d", drawLine(loadValues1[i], line, xScale, dimfilters, dragging))
                            }) 
                            .transition()
                            .delay(500)
                            .duration(0)
                            d3.select(".background").attr("visibility", null);
                        });

                        var dimensionElement =  <g className={'dimension '+dim.name} transform={'translate('+xScale(dim.name)+')'} ref={node => d3Select(node).call(drag)} >
                        <g className={'axis'} ref={node => d3Select(node).call(d3AxisLeft(dim.scale))}>       
                        </g>
                        <text className="title" textAnchor="middle" y={"-9"}>{dim.name}</text>
                        <g id={dim.name} className={id+'_parallelCoordinatesbrush brush'} ref={node => d3Select(node)
                                                        .call(dim.brush)
                                                        }>
                    </g>
                        </g>
                        dimBrushInstances[dim.name] = dim.brush
                    dimensionElements.push(dimensionElement)
            })

            $.each(loadValues1, function (index, value) {
                var linePathFore = <path 
                d={drawLine(value, line, xScale, dimfilters, dragging)} 
                className={"forepath "+(value["ID"]-1+" forepath"+id)} id={id+"_"+(value["ID"]-1)}
                ></path>
        
                var linePathBack = <path 
                d={drawLine(value, line, xScale, dimfilters, dragging)} 
                className={"backpath "+(value["ID"]-1)}
                ></path>
        
            backgroundElementsForeground.push(linePathFore)
            backgroundElementsBackground.push(linePathBack)
          
            })
        
        }

//http://plnkr.co/edit/dCNuBsaDNBwr7CrAJUBe?p=preview
//http://plnkr.co/edit/RkWBgQ6oi584H3212WrM?p=preview
   
   
    



    var graph: any = "";

 

    if (
        graphOptions == PREDICTION
    ) {

        return (
            <>
            {""}
            <svg
                className={id + "chart"}
                id={id + "_svg_parallel_coordinates_draw"}
                height={height + margin.left + margin.right}
                width={width + margin.top + margin.bottom}
            >
                
                <g
                    transform={"translate(" + margin.left + ", " + margin.top + ")"}
                    id={id + "_svg_parallel_coordinates"}
                >
                      <g className='predictionDummyyy'>

                        </g>

                   <g className='prediction' id={id+'prediction'}></g>
                   {dimensionElements}
                </g>
            </svg>
        </>
        );
    }
    if (graphOptions == '') {

     
        predictionParallelCoordinates = ''
        var stylePrediction={'opacity': 0.6}

        console.log('backgroundElementsBackground',backgroundElementsBackground)

     
    

        return (
            <>
        {""}
        <svg
            className={id + "chart"}
            id={id + "_svg_parallel_coordinates_draw"}
            height={height + margin.left + margin.right}
            width={width + margin.top + margin.bottom}
        >
            
            <g
                transform={"translate(" + margin.left + ", " + margin.top + ")"}
                id={id + "_svg_parallel_coordinates"}
            >
                
                <g className='predictionActualDummy'>

                </g>
               
         
             
                
               {dimensionElements}
            </g>
        </svg>
    </>
        );
    }

    if (graphOptions == SEEDATA) {

     
            predictionParallelCoordinates = ''
            var stylePrediction={'opacity': 0.6}

            console.log('backgroundElementsBackground',backgroundElementsBackground)

         
        

            return (
                <>
            {""}
            <svg
                className={id + "chart"}
                id={id + "_svg_parallel_coordinates_draw"}
                height={height + margin.left + margin.right}
                width={width + margin.top + margin.bottom}
            >
                
                <g
                    transform={"translate(" + margin.left + ", " + margin.top + ")"}
                    id={id + "_svg_parallel_coordinates"}
                >
                    
                    <g className='predictionActualDummy'>

                    </g>
                   
                    <g className={'background'}>
                        {backgroundElementsBackground}
                    </g>
                    <g className='predictionActual' style={stylePrediction}>

</g>
                    <g className={'foreground'}>
                        {backgroundElementsForeground}
                    </g>
                 
                    
                   {dimensionElements}
                </g>
            </svg>
        </>
            );
        }

};
export default ParllelCoordinates;


function drawLine(d, line, xScale, dims, dragging) {
    return line(dims.map(function(dimension) {
       /* var v = dragging[dimension.name];
        var tx = v == null ? xScale(dimension.name) : v;
        return [tx, dimension.scale(d[dimension.name])];
         */           
      return [ position(dragging, dimension.name, xScale), dimension.scale(d[dimension.name])];
    }));
  }
  

  function position(dragging, d, xScale) {
     
    var v = dragging[d];
    var value = v == null ? xScale(d) : v;
  
    return  value
  }
  
  function transition(g) {
    return g.transition().duration(500);
  }




  function brushstart(extents, dimfilters, selectionName, id, dimBrushInstances,zaxisList, event) {
    
    d3select('.foreground').selectAll("path").style("display", "none")
  
    if(BrushingDataSet.currentGraphID!=id)
    {
    clearAllBrushes()
    }
  
    var dimensionsIndex = dimfilters.indexOf(selectionName);
   
    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
    if(logevents)
    {
            var eventlog = LogEvents.addEvent(id, PARALLEL_COORDINATES_CHART, ACTUAL,LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, null, null,null,null,zaxisList)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
    }
    
    extents[dimensionsIndex] = [0, 0];
    var datasetIds  = []
    var pathElements = document.getElementsByClassName("forepath"+id)
    for (let i = 0; i < pathElements.length; i++) {
       
        var ID = pathElements[i].classList[1]

     

        var display = dimfilters.every(function(element, index, array) {
            
            if(element.type == 'string')
            {
                if(extents[index][0]==0 && extents[index][1]==0) {
                    return true;
                }
              return extents[index].includes(loadValues1[ID][element.name]);
            }
            else
            {
                if(extents[index][0]==0 && extents[index][1]==0) {
                    return true;
                }
              return extents[index][1] <= loadValues1[ID][element.name] && loadValues1[ID][element.name] <= extents[index][0];
            }
           
        }) ? "block" : "none";
        if(display == 'block')
        {
            datasetIds.push((Number.parseInt(ID)+1))
            pathElements[i].setAttribute("style","opacity: 1; stroke:" + BRUSHING_COLOR+"; stroke-width:"+2)
        }
        else
        {
            pathElements[i].setAttribute("style","opacity: 0.5; stroke:" + REALDATA_COLOR+"; stroke-width:"+2)
        }
       

    }
    if(!(BrushingDataSet.currentGraphBrushInstance instanceof Map))
    {
        console.log('dimfiltersdimfilters',dimfilters)
        BrushingDataSet.currentGraphBrushInstance = new Map<string,any>()
        BrushingDataSet.currentGraphBrushInstance[selectionName] = dimBrushInstances[selectionName]
    }
    else
    {
        BrushingDataSet.currentGraphBrushInstance[selectionName] = dimBrushInstances[selectionName]
    }
   
    BrushingDataSet.currentGraphID = id
    BrushingDataSet.currentGraphType = PARALLEL_COORDINATES_CHART
    BrushingDataSet.currentGraphData = datasetIds
    BrushingDataSet.currentGraphEnable = 0


    parallelCoordinatesPlotBrush(0, id, datasetIds)
   
  }
  

  function go_brush() {
    d3.event.sourceEvent.stopPropagation();
  }
 
  
  function brush_parallel_chart(extents,dimfilters, id, dimBrushInstances, event) { 

    for(var i=0;i<dimfilters.length;++i){
         if(d3.event.target==dimfilters[i].brush) {
          //if (d3.event.sourceEvent.type === "brush") return;
            if(d3.event.selection!=null)
            {
               
                   
                    if(dimfilters[i].type == 'string')
                    {
                        
                      
                        if(d3.event.selection[1] == 0 || d3.event.selection[1] == 1 || d3.event.selection[1] == undefined)
                        {

                        }
                        else
                        {
                            extents[i]=dimfilters[i].scale.invert(d3.event.selection[0], d3.event.selection[1])
                        }
                        console.log('dimfilters[i].scale.scaleBand', dimfilters[i].type,dimfilters[i], d3.event.selection, extents[i])
                    }
                    else
                    {
                        extents[i]=d3.event.selection.map(dimfilters[i].scale.invert,dimfilters[i]);
                        console.log('dimfilters[i].scale.scaleBand', dimfilters[i].type,dimfilters[i], d3.event.selection, extents[i])

                    }
             
                  
  
               
            }
              
 
        }
    }

    var pathElements = document.getElementsByClassName("forepath"+id)
    var datasetIds  = []
    for (let i = 0; i < pathElements.length; i++) {
        var ID = pathElements[i].classList[1]
      
        var display = dimfilters.every(function(element, index, array) {
          
            if(element.type == 'string')
            {
                if(extents[index][0]==0 && extents[index][1]==0) {
                    return true;
                }
              return extents[index].includes(loadValues1[ID][element.name]);
            }
            else
            {
                if(extents[index][0]==0 && extents[index][1]==0) {
                    return true;
                }
              return extents[index][1] <= loadValues1[ID][element.name] && loadValues1[ID][element.name] <= extents[index][0];
            }
           
        }) ? "block" : "none";
        if(display == 'block')
        {
            datasetIds.push((Number.parseInt(ID)+1))
         
            pathElements[i].setAttribute("style","opacity: 1; stroke:" + BRUSHING_COLOR+"; stroke-width:"+2)
        }
        else
        {
            pathElements[i].setAttribute("style","opacity: 0.5; stroke:" + REALDATA_COLOR+"; stroke-width:"+2)
        }
       

    }
    console.log('datasetIdspar',datasetIds)
    BrushingDataSet.currentGraphID = id
    BrushingDataSet.currentGraphType = PARALLEL_COORDINATES_CHART
    BrushingDataSet.currentGraphData = datasetIds
    BrushingDataSet.currentGraphEnable = 0
   
    parallelCoordinatesPlotBrush(0, id, datasetIds)
       
 } 


 
 function brush_end(extents,dimfilters, id,xScale, zaxisList, event){

    if(histogramPredictionDataset.getPredictionParallelCoordinatesChart(id) != null)
    {
       var predictionParallelCoordinates = histogramPredictionDataset.getPredictionParallelCoordinatesChart(id)
        console.log('predictionParallelCoordinatesseedata',predictionParallelCoordinates)

        var graph_forepaths= document.getElementsByClassName("forepath");

        for (let i = 0; i < graph_forepaths.length; i++) {
  
          graph_forepaths[i].setAttribute(
            "style",
            "opacity: 0.2; stroke: "+"grey"+"; "
            );
        }
        for(var row=0;row<predictionParallelCoordinates.axesPrediction.length;row++)
        {
          var predictionParallelCoordinate:ParallelCoordinatesPrediction = predictionParallelCoordinates.axesPrediction[row]
          var dataAll = []
          for (let [key, value] of Object.entries(predictionParallelCoordinate.predictionPoints)) {
                var data = value[0]

               drawPredictionActual(key, value, xScale, predictionParallelCoordinate)
                var keys = key.split(":")
                dataAll.push([key,value])
               
          }
          drawPredictionLineActual(dataAll, row)

        }

       
    }

    


    if (!d3.event.sourceEvent) return; // Only transition after input.
    if (!d3.event.selection) return; // Ignore empty selections.
  
    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
    if(logevents)
    {
            var eventlog = LogEvents.addEvent(id, PARALLEL_COORDINATES_CHART, ACTUAL,LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, null, extents,null,null,zaxisList)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
    }
  
  for(var i=0;i<dimfilters.length;++i){
  
      if(d3.event.target==dimfilters[i].brush) {
  
        if(dimfilters[i].type == 'string')
        {
            
          
            if(d3.event.selection[1] == 0 || d3.event.selection[1] == 1 || d3.event.selection[1] == undefined)
            {

            }
            else
            {
                extents[i]=dimfilters[i].scale.invert(d3.event.selection[0], d3.event.selection[1])
            }
            console.log('dimfilters[i].scale.scaleBand', dimfilters[i].type,dimfilters[i], d3.event.selection, extents[i])
        }
        else
        {
            extents[i]=d3.event.selection.map(dimfilters[i].scale.invert,dimfilters[i]);
            console.log('dimfilters[i].scale.scaleBand', dimfilters[i].type,dimfilters[i], d3.event.selection, extents[i])

        }


   
  
     extents[i][0] = Math.round( extents[i][0] * 10 ) / 10;
     extents[i][1] = Math.round( extents[i][1] * 10 ) / 10;
  
  
  
      d3.select(this).transition().call(d3.event.target.move, extents[i].map(dimfilters[i].scale));
  
       }
  
    }
  
  }

  function newExtent(predictionParallelCoordinates, dim, xScale, brushRectIds, selection){

    var rectId =  "rect"+Math.floor((Math.random() * 1000) + 1).toString()
    var row,
    axesExists = true
   
   // console.log('newextent',rectId, brushRectIds, dim.name, selection[0] )
    if(!isNull(selection[0]))
    {
        console.log('newextent',rectId, brushRectIds, dim.name, selection[0] )
        if(brushRectIds[dim.name] == null)
        {   var arrayIds = new Array<string>()
            arrayIds.push(rectId)
            brushRectIds[dim.name] = arrayIds
          
        }
        else
        {
            console.log('newextent 11',brushRectIds[dim.name].push(rectId),rectId)
            brushRectIds[dim.name].push(rectId)
        }

        selection
        .attr("id", rectId)
        .attr("x", -8)
        .attr("width", 16);
    
    }
   
  
    

   
  }

  function resizeExtent(predictionParallelCoordinates, dim, xScale,  selection){
     
      selection
		.attr("x", -8)
		.attr("width", 16);
}

function isNull(inputArray) {
    if (inputArray.length) {
        var currentElement = inputArray[0];
        for (var i = 1, len = inputArray.length; i < len && currentElement === null; i += 1) {
            currentElement = currentElement || inputArray[i];
        }
        if (currentElement !== null) {
            console.log('currentElement',currentElement)
            return false;
        }
    }
    return true;
}

function scaleBand(yScale){
    console.log('Invert',yScale)
  var eachBand = yScale.step();
  var index = Math.round((d3.event.y / eachBand));
  return yScale.domain()[index];

}